<script>
  import ButtonWithTooltip from "@sourcewhale/shared/svelte-design-system/components/atoms/ButtonWithTooltip.svelte";
  import { convertToEmail } from "./utils";

  import { candidateStore } from "../stores";

  $: disabled = ($candidateStore.emails || []).length === 0;

  const onclick = async () => {
    if (disabled) return;

    await convertToEmail();
  };
</script>

<ButtonWithTooltip
  kind="secondary"
  leadingIcon="fa-solid fa-envelope"
  class="flex-1 {disabled ? 'disabled' : ''}"
  {onclick}
  size="large"
  placement="top"
>
  <span slot="tooltip">
    {#if disabled}
      Add an email address to this contact<br />to convert this InMail step into
      an email
    {:else}
      Convert this InMail step into<br />an email to continue outreach
    {/if}
  </span>
  Convert to email
</ButtonWithTooltip>
